// Ordered list of service names that should appear first in this exact order
// (the most common services / repairs). Matching is case-insensitive and trims
// whitespace. Anything not listed keeps its natural order; "Andet?" is forced last.
const PRIORITY_ORDER = [
  "standard service eftersyn",
  "service eftersyn jf. fabrikkens forskrifter",
  "hjulskifte",
  "dækskifte",
  "dækrotation",
  "nye dæk",
  "fejlsøgning/diagnose",
  "rens af bremser for eller bag",
  "rens af alle bremser",
  "udskiftning af bremser",
  "vinter-/sommertjek",
  "synsforberedelse",
  "lav volts batteri helbredstjek",
  "batteri sundhedsrapport (soh)",
  "udskiftning af viskerblade",
  "airconditionrens",
];

const normalize = (name) => (name || "").trim().toLowerCase();
const isAndet = (s) => normalize(s?.name).includes("andet");

/**
 * Returns a new array of services sorted with the configured priority names first
 * (in the configured order), then the remaining services, with any "Andet?"
 * service pushed to the very end.
 */
export const sortServicesCustom = (services) => {
  const list = Array.isArray(services) ? [...services] : [];
  return list.sort((a, b) => {
    const aAndet = isAndet(a);
    const bAndet = isAndet(b);
    if (aAndet && !bAndet) return 1;
    if (!aAndet && bAndet) return -1;

    const aIdx = PRIORITY_ORDER.indexOf(normalize(a.name));
    const bIdx = PRIORITY_ORDER.indexOf(normalize(b.name));
    const aHas = aIdx !== -1;
    const bHas = bIdx !== -1;
    if (aHas && bHas) return aIdx - bIdx;
    if (aHas) return -1;
    if (bHas) return 1;
    return 0;
  });
};
